import { render, staticRenderFns } from "./FreightTemplate.vue?vue&type=template&id=215c1b90&"
import script from "./FreightTemplate.vue?vue&type=script&lang=js&"
export * from "./FreightTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports